import { apiSlice } from '../api/apiSlice';

export const storageApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadImages: builder.mutation({
      query: (formData: FormData) => ({
        url: `/storage/upload-images`,
        method: 'POST',
        body: formData,
      }),
    }),
  }),
});
export const { useUploadImagesMutation } = storageApiSlice;
